export default __webpack_public_path__ + "static/media/Neutrif-Studio-ExtraBold.9580428d.ttf";